import { gql } from '../types/generated';

export const GET_AD_EVENT_TYPES = gql(`
  query adEventTypes($sport: Sport = MLB) {
    adEventTypes(sport: $sport) {
      label
      value
    }
  }
`);

export const GET_LOGGER_SCHEDULE = gql(`
  query loggerSchedule($date: String = "", $sports: [Sport] = [MLB]) {
    schedule(date: $date, sports: $sports) {
      away {
        ...TeamFields
      }
      home {
        ...TeamFields
      }
      venue {
        id
        name
      }
      gameDate
      gamePk
      status
      pipelines {
        id
        feedType
        programSource
        status
      }
      feeds {
        feedType
        preGameShow
        postGameShow
      }
    }
  }
`);

export const GET_LOGGER_GAME = gql(`
  query loggerGame($gamePk: Int!, $scheduleDate: String) {
    game(gamePk: $gamePk, scheduleDate: $scheduleDate) {
      away {
        id
        abbreviation
      }
      home {
        id
        abbreviation
      }
      feeds {
        feedType
        postGameShow
        preGameShow
      }
      gamePk
      status
      content {
        callSign
        feedType
        mediaId
        mediaState {
          mediaType
          state
        }
      }
      pipelines {
        id
        activeSlateCode
        adBreakDurationInSeconds
        adBreakStartedDateTime
        feedType
        programSource
        status
        sourceSystem
        scheduledStartDateTime
        streamState
        resumedFromDateTime
        media {
          id
          mediaType
          feedType
          language
        }
        red5Config {
          primaryHost
          primaryNodeGroup
          backupHost
          backupNodeGroup
          preProcStreamName
          postProcStreamName
        }
      }
    }
  }
`);

export const GET_SLATES = gql(`
  query slates($sport: Sport = MLB, $type: SlateType) {
    slates(sport: $sport, type: $type) {
      id
      code
      type
      description
      thumbnailUri
      sourceSystem
    }
  }
`);
